import React, { Fragment } from "react";

import img13 from "../../../images/service/White-Label Crypto Wallet/1.png";
import img14 from "../../../images/service/White-Label Crypto Wallet/2.png";
import img15 from "../../../images/service/White-Label Crypto Wallet/3.png";

import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";

// --------------------------------------------------
// DATA
// --------------------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "White-Label Wallet Setup",
    content:
      "Launch a fully branded crypto wallet with ready-to-use infrastructure.",
  },
  {
    icon: sIcon2,
    title: "Multi-Currency Wallet",
    content:
      "Support multiple cryptocurrencies and tokens across major blockchains.",
  },
  {
    icon: sIcon3,
    title: "Wallet Integration",
    content:
      "Integrate wallets with exchanges, DeFi apps, and payment gateways.",
  },
];

const benefits = [
  {
    title: "Faster Launch",
    description:
      "Deploy your crypto wallet quickly using pre-built and tested frameworks.",
    icon: sIcon1,
  },
  {
    title: "Enterprise-Grade Security",
    description:
      "Advanced encryption, private key protection, and secure storage layers.",
    icon: sIcon2,
  },
  {
    title: "Custom Branding",
    description:
      "Personalized UI, logo, colors, and user experience under your brand.",
    icon: sIcon3,
  },
  {
    title: "Multi-Platform Support",
    description:
      "Wallets compatible with web, mobile (iOS & Android), and desktop.",
    icon: sIcon4,
  },
  {
    title: "Scalable Architecture",
    description:
      "Built to support growing users, assets, and transaction volumes.",
    icon: sIcon5,
  },
  {
    title: "Compliance-Ready",
    description:
      "Supports KYC, AML, and audit-friendly wallet operations.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is a white-label crypto wallet?",
    a: "A white-label crypto wallet is a ready-made wallet solution that can be branded and customized for your business.",
  },
  {
    q: "Can the wallet support multiple blockchains?",
    a: "Yes. Our wallets support multiple blockchains and token standards.",
  },
  {
    q: "Are private keys secure?",
    a: "Yes. We implement encryption, cold storage, and secure key management.",
  },
  {
    q: "Can the wallet be integrated with exchanges?",
    a: "Yes. Wallets can be integrated with crypto exchanges, DeFi platforms, and payment systems.",
  },
];

// --------------------------------------------------
// PAGE COMPONENT
// --------------------------------------------------

export default function WhiteLabelCryptoWalletDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="White-Label Crypto Wallet Development"
        pagesub="Launch a secure and branded cryptocurrency wallet"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Build Your Own{" "}
            <span className="gradient-text">White-Label Crypto Wallet</span>
          </>
        }
        subtitle={`Our white-label crypto wallet solutions help businesses launch
secure, scalable, and user-friendly wallets with complete branding control.`}
        buttonText="Build My Wallet"
        buttonLink="/contact"
        image={img13}
        imageAlt="White-Label Crypto Wallet Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is White-Label Crypto Wallet Development?"
        image={img14}
        paragraphs={[
          "White-label crypto wallet development allows businesses to deploy a ready-to-use wallet solution without building the system from scratch. These wallets come with essential features like private key management, transaction handling, and multi-currency support.",
          "Businesses can fully customize the wallet’s interface, branding, and functional modules while relying on a proven backend infrastructure that ensures security, performance, and scalability.",
        ]}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Businesses Choose White-Label Wallets"
        image={img15}
        paragraphs={[
          "Developing a crypto wallet from scratch requires extensive security audits, blockchain expertise, and ongoing maintenance. White-label wallets eliminate these challenges by offering a tested and compliant solution.",
          "This approach allows startups and enterprises to focus on market growth, customer onboarding, and product expansion while ensuring a secure digital asset experience for users.",
        ]}
      />

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our White-Label Wallet Services"
        cards={serviceCards}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit
        title="Benefits of White-Label Crypto Wallet Development"
        benefits={benefits}
      />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of Our Crypto Wallets"
        subtitle="Designed for security, usability, and scalability."
        features={[
          {
            icon: sIcon1,
            title: "Private Key Control",
            description:
              "Secure storage and encryption for user private keys.",
          },
          {
            icon: sIcon2,
            title: "Multi-Currency Support",
            description:
              "Support popular cryptocurrencies and tokens.",
          },
          {
            icon: sIcon3,
            title: "Transaction Management",
            description:
              "Fast and reliable transaction processing.",
          },
          {
            icon: sIcon4,
            title: "Cross-Platform Compatibility",
            description:
              "Web, mobile, and desktop wallet solutions.",
          },
          {
            icon: sIcon5,
            title: "Backup & Recovery",
            description:
              "Seed phrase and wallet recovery mechanisms.",
          },
          {
            icon: sIcon6,
            title: "Compliance Tools",
            description:
              "KYC, AML, and transaction monitoring features.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Secure Wallet Architecture",
          "Fully Customizable Branding",
          "End-to-End Wallet Development",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
